import * as ex from "excalibur";
import { Resources } from "../../Resources";
import { Config } from "../../config";
import { getHouseContent } from "../../content/houseContent";
import { gameState } from "../../state/stateManager";
import Dialog from "../../ui/dialog";

export class Grandpa extends ex.Actor {
  constructor(x, y) {
    super({
      x: x,
      y: y,
      width: 32,
      height: 32,
      radius: 10,
      collisionType: ex.CollisionType.Fixed,
      name: "grandpa",
    });
    this.interacting = false;
    this.grandpa = this;
    this.graphic = "down-idle";
  }
  onCollisionStart(engine) {
    console.log("collision");
  }
  onInitialize(engine) {
    let game = gameState.getCurrentGame();
    console.log("game is: ", game);
    this.houseContent = getHouseContent(
      game.player.name,
      "Kozzz"
    ).getGrandpaGreetings();
    const playerSpriteSheet = ex.SpriteSheet.fromImageSource({
      image: Resources.GrandpaSpriteSheetPng,
      grid: {
        spriteWidth: 32,
        spriteHeight: 32,
        rows: 8,
        columns: 8,
      },
    });

    const leftIdle = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 2),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    this.graphics.add("left-idle", leftIdle);

    const rightIdle = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(7, 3),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    this.graphics.add("right-idle", rightIdle);

    const upIdle = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 1),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    this.graphics.add("up-idle", upIdle);

    const downIdle = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 0),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    this.graphics.add("down-idle", downIdle);

    const leftWalk = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 2),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    this.graphics.add("left-walk", leftWalk);

    const rightWalk = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 3),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    this.graphics.add("right-walk", rightWalk);

    const upWalk = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 1),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    this.graphics.add("up-walk", upWalk);

    const downWalk = new ex.Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 0),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    this.graphics.add("down-walk", downWalk);
  }
  onPostUpdate(engine) {
    if (this.interacting) {
      if (engine.input.keyboard.wasPressed(ex.Keys.Enter)) {
        console.log("enterPress Grandpa");
        this.greetingDialog.enterPress();
      }
    }
  }
  startInteraction(lastDir, player) {
    Resources.Footsteps.stop();
    this.interacting = true;
    player.cutScene = true;
    console.log("inside startInteraction, ", lastDir);
    switch (lastDir) {
      case "left":
        this.graphics.use("right-idle");
        break;
      case "right":
        this.graphics.use("left-idle");
        break;
      case "up":
        this.graphics.use("down-idle");
        break;
      case "down":
        this.graphics.use("up-idle");
        break;
      default:
        break;
    }
    var greeting =
      this.houseContent[Math.floor(Math.random() * this.houseContent.length)];
    console.log("greeting: ", greeting);
    this.greetingDialog = new Dialog(
      [greeting],
      () => {
        console.log("dialog ended");
        player.cutScene = false;
      },
      "grandpa"
    );
  }
  moveFunction(direction, amount) {
    console.log("cutscene: inside grandpa move");
    switch (direction) {
      case "left":
        this.graphics.use("left-walk");
        this.vel = ex.vec(-Config.GrandpaSpeed, 0);

        this.lastDir = "left";
        break;
      case "right":
        this.graphics.use("right-walk");
        this.vel = ex.vec(Config.GrandpaSpeed, 0);

        this.lastDir = "right";
        break;
      case "up":
        this.graphics.use("up-walk");
        this.vel = ex.vec(0, -Config.GrandpaSpeed);

        this.lastDir = "up";
        break;
      case "down":
        this.graphics.use("down-walk");
        this.vel = ex.vec(0, Config.GrandpaSpeed);

        this.lastDir = "down";
        break;
      default:
        break;
    }
  }
  onPreUpdate(engine, elapsedMs) {
    this.vel = ex.Vector.Zero;
    if (!this.interacting && !this.cutScene) {
      this.graphics.use("down-idle");
    } else {
      this.graphics.use(this.graphic);
    }
  }
}
